/**
 * Taking the final stage over from the person the admin named for it (the
 * user, 2026-10-21).
 *
 * Mirrors backend finalTakeoverFor (src/monthlyReport/reportAccess.mjs): a
 * global or finance director who was NOT the one named may still approve, but
 * is told first who was named and asked to confirm - and the named person is
 * emailed. The server is the authority; this only decides when to ask.
 */

import { namedCoverActive } from '../../utils/namedCover.mjs';

export { namedCoverActive };

const FINAL_APPROVERS = new Set(['global_director', 'finance_director']);

/** Is the report at its final stage? A report that skips the regional stage goes there from the auditor. */
export const awaitingFinal = (report) => report?.status === 'regional_director_approved'
  || (report?.status === 'auditor_approved' && report?.approvalPath === 'skip_regional');

/**
 * The name of the person named for final approval when this final approver is
 * someone else, or null when there is nothing to take over.
 */
export const finalApproverNamedOtherThan = (report, user, now = new Date()) => {
  if (!report || !user || !awaitingFinal(report) || !FINAL_APPROVERS.has(user.role)) return null;
  if (!report.globalApproverId || !namedCoverActive(report, now)) return null;
  if (String(report.globalApproverId) === String(user.id)) return null;
  return report.globalApproverName || 'the named final approver';
};

const finalTakeover = { awaitingFinal, namedCoverActive, finalApproverNamedOtherThan };
export default finalTakeover;
